module.exports = __webpack_public_path__ + "static/quiz_mhnn_manger4-2583606607f90438cadc01a10085d6d5.png";